// extracted by mini-css-extract-plugin
export default {"tournamentInfoEntry":"TournamentInfoEntry_tournamentInfoEntry__iOwGy"};